import { render, staticRenderFns } from "./ModelingDrawer.vue?vue&type=template&id=35cdbffe&scoped=true"
import script from "./ModelingDrawer.vue?vue&type=script&lang=js"
export * from "./ModelingDrawer.vue?vue&type=script&lang=js"
import style0 from "./ModelingDrawer.vue?vue&type=style&index=0&id=35cdbffe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cdbffe",
  null
  
)

export default component.exports